import { Fab } from '@biq/apex-ui';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Grid, Typography } from '@mui/material';
import React from 'react';
import { DashboardEmptyStateIcon } from '../../../../assets';
import {
    dashboardEmptyStateHelperStyles,
    DashboardEmptyStateProps,
} from './dashboard-empty-state-heper';

export const DashboardEmptyState = ({
    refreshData,
}: DashboardEmptyStateProps): React.JSX.Element => {
    const handleRefreshMetricsButtonClick = (): void => {
        refreshData();
    };

    return (
        <Grid sx={dashboardEmptyStateHelperStyles.mainContainer}>
            <img
                style={dashboardEmptyStateHelperStyles.image}
                src={DashboardEmptyStateIcon}
                alt='dashboard-empty-state-icon'
            />
            <Typography sx={dashboardEmptyStateHelperStyles.mainText}>
                Your SDZ Metrics are Being Gathered
            </Typography>
            <Typography sx={dashboardEmptyStateHelperStyles.secondaryText}>
                Check Back Later
            </Typography>
            <Fab
                type='button'
                sx={dashboardEmptyStateHelperStyles.refreshButton}
                icon={<RefreshIcon />}
                color='secondary'
                label='REFRESH PAGE'
                onClick={handleRefreshMetricsButtonClick}
            />
        </Grid>
    );
};
